/* eslint-disable no-restricted-imports */
import { IFontStyles, ITextProps, Text } from 'office-ui-fabric-react';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

/**
 * UI Type Ramp
 * From designs:
 * https://app.abstract.com/projects/b289b0f5-824d-4000-ab4a-c7a010e456e1/branches/master/commits/e4bcdd9e4b4aa7c1d25161ffa8c873fc0c9e4902/files/4D2DD9E5-936B-4C78-9067-7845BA6C0A79/layers/C972D75B-C2A9-46E4-869B-55F193A12E06?collectionId=0d7be81f-58df-4e69-bafa-be6b3e582c2f&collectionLayerId=3fdf6b75-bf02-4f1a-8484-944106a5d422
 */
const wrapText = (variant: keyof IFontStyles): FunctionComponent<ITextProps> => {
  const Typography: FunctionComponent<ITextProps> = props => {
    const { children, ...rest } = props;
    return (
      <Text variant={variant} {...rest}>
        {children}
      </Text>
    );
  };

  return Typography;
};

const bold = 'font-weight: 600;';

export const caption1Size = '10px';
export const caption1Font = `font-size: ${caption1Size};`;
export const Caption1Text = wrapText('tiny');

export const caption2Size = '12px';
export const caption2Font = `font-size: ${caption2Size};`;
export const Caption2Text = wrapText('small');

export const body1Size = '14px';
export const body1Font = `font-size: ${body1Size};`;
export const Body1Text = wrapText('medium');

export const body1BoldFont = `font-size: ${body1Size}; ${bold}`;
export const Body1BoldText = styled(wrapText('medium'))`
  ${bold}
`;

export const body2Size = '16px';
export const body2Font = `font-size: ${body2Size};`;
export const Body2Text = wrapText('mediumPlus');

export const body2BoldFont = `font-size: ${body2Size}; ${bold}`;
export const Body2BoldText = styled(wrapText('mediumPlus'))`
  ${bold}
`;

export const subhead2Size = '20px';
export const subhead2BoldFont = `font-size: ${subhead2Size}; ${bold}`;
export const Subhead2BoldText = styled(wrapText('xLarge'))`
  ${bold}
`;

export const subhead3Size = '24px';
export const subhead3Font = `font-size: ${subhead3Size};`;
export const Subhead3Text = wrapText('xLargePlus');

export const title2Size = '32px';
export const title2Font = `font-size: ${title2Size};`;
export const Title2Text = wrapText('xxLargePlus');
